import { IsArray, IsOptional, IsString } from "class-validator";

export class TemplateFloorplansDto {
  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  tags?: string[];
}
